import { render, staticRenderFns } from "./CreateWorkGroup.vue?vue&type=template&id=aaf6f934&"
import script from "./CreateWorkGroup.vue?vue&type=script&lang=js&"
export * from "./CreateWorkGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports